import { handleActions } from 'redux-actions';
import {
  sectionIdListStatementContentLoading,
  sectionIdListStatementContentLoaded,
  sectionIdListStatementContentError,
  clearStatementPageStoreAction,
} from 'store/actions/statement-content-actions';
import { SectionIdList } from 'models/api/section-id-list-model';

export default handleActions(
  {
    [sectionIdListStatementContentLoading]: (sectionIdList) => {
      return sectionIdList.setLoading();
    },
    [sectionIdListStatementContentLoaded]: (sectionIdList, { payload }) => {
      return sectionIdList.setLoaded(payload);
    },
    [sectionIdListStatementContentError]: (sectionIdList, { payload }) => {
      return sectionIdList.setError(payload);
    },
    [clearStatementPageStoreAction]: (sectionIdList, { payload }) => {
      return new SectionIdList();
    },
  },
  new SectionIdList(),
);
